import {
  Button,
  PaginationProps,
  Table,
  Space,
  Tooltip,
  Pagination,
  Popover,
} from "antd";
import { ColumnsType } from "antd/es/table";
import React from "react";
import { CONSTANT } from "../../../../config/Constant";
import {
  EditOutlined,
  DeleteOutlined,
  CloudDownloadOutlined,
} from "@ant-design/icons";
interface DataType {
  company_name: string | any;
  id: string | any;
  main_id: string | any;
  company_number: string | any;
  name: string | any;
  file_download_link: string | any;
  description: string | any;
}
const ListComponent: React.FC<any> = (props) => {
  const {
    listData,
    savePayload,
    tableloading,
    setListData,
    setTableLoading,
    setPaginationData,
    getList,
    paginationData,
    totalData,
    handleEditModal,
    handleDeleteModal,
  } = props;

  const data: DataType[] = listData?.map((item: any, index: number) => ({
    company_name: item?.company_name ?? item?.company_name,
    id: item?.index ?? index + 1,
    main_id: item?._id,
    company_number: item?.company_number,
    name: item?.name,
    file_download_link: item?.file_download_link,
    description: item?.description,
  }));
  const TextWithTooltip = (data: any) => {
    if (data && data?.length > 50) {
      return (
        <span>
          <Popover overlayClassName="desTooltip" title={data} trigger={"hover"}>
            <span style={{ cursor: "pointer" }}>{data.slice(0, 50)}...</span>
          </Popover>
        </span>
      );
    } else {
      return <span>{data}</span>;
    }
  };
  const handleChange: PaginationProps["onChange"] = (current, page_size) => {
    setListData([]);
    setTableLoading(true);
    setPaginationData({
      page_number: current,
      page_size: page_size,
    });
    const updateData = {
      ...savePayload,
      page_number: current,
      page_size: page_size,
    };
    getList(updateData);
  };
  const onShowSizeChange: PaginationProps["onShowSizeChange"] = (
    current,
    page_size
  ) => {
    setListData([]);
    setTableLoading(true);
    setPaginationData({
      page_number: current,
      page_size: page_size,
    });
    const updateData = {
      ...savePayload,
      page_number: current,
      page_size: page_size,
    };
    getList(updateData);
  };

  const columns: ColumnsType<any> = [
    {
      title: "ID",
      dataIndex: "id",
      key: "id",
      width: 100,
      sortDirections: ["descend", "ascend"],
      sorter: (a, b) => a?.id?.toString().localeCompare(b?.id),
    },
    {
      title: "Company Name",
      dataIndex: "company_name",
      key: "company_name",
      width: 150,
      sortDirections: ["descend", "ascend"],
      sorter: (a, b) =>
        a?.company_name?.toString().localeCompare(b?.company_name),
      render: (_, record) => {
        return record?.company_name
          ? record?.company_name
          : CONSTANT.NO_DATA_FOUND;
      },
    },
    {
      title: "Number",
      dataIndex: "company_number",
      key: "company_number",
      width: 150,
      sortDirections: ["descend", "ascend"],
      sorter: (a, b) =>
        a?.company_number?.toString().localeCompare(b?.company_number),
      render: (_, record) => {
        return record?.company_number
          ? record?.company_number
          : CONSTANT.NO_DATA_FOUND;
      },
    },
    {
      title: "Name",
      dataIndex: "name",
      key: "name",
      width: 150,
      sortDirections: ["descend", "ascend"],
      sorter: (a, b) => a?.name?.toString().localeCompare(b?.name),
      render: (_, record) => {
        return record?.name ? record?.name : CONSTANT.NO_DATA_FOUND;
      },
    },
    {
      title: "Description",
      key: "description",
      dataIndex: "description",
      width: 150,
      sortDirections: ["descend", "ascend"],
      sorter: (a, b) => a?.description?.localeCompare(b?.description),
      render: (_, record) => {
        return record?.description && record?.description?.length > 0 ? (
          <>{TextWithTooltip(record.description)}</>
        ) : (
          CONSTANT.NO_DATA_FOUND
        );
      },
    },

    {
      title: "Action",
      key: "action",
      width: 150,
      fixed: "right",
      render: (_, record) => {
        console.log("recired", record.file_download_link);

        return (
          <Space size="middle">
            <Tooltip title={"Edit"}>
              <Button
                type="default"
                icon={<EditOutlined />}
                className="EditBtn iconBtn"
                onClick={() => handleEditModal(record)}
              />
            </Tooltip>
            <Tooltip title={"Download File"}>
              <Button
                href={record.file_download_link}
                icon={<CloudDownloadOutlined />}
                type="default"
                disabled={record.file_download_link === "" ? true : false}
                target="_blank"
                className="iconBtn"
              />
            </Tooltip>
            <Tooltip title={"Delete"}>
              <Button
                onClick={() => {
                  handleDeleteModal(record);
                }}
                icon={<DeleteOutlined />}
                type="default"
                className="cancelBtn iconBtn"
              />
            </Tooltip>
          </Space>
        );
      },
    },
  ];
  return (
    <>
      <div className="responsiveTable">
        <Table
          dataSource={data}
          columns={columns}
          pagination={false}
          loading={tableloading}
          bordered
          size="small"
          scroll={{ x: 1000, y: 400 }}
          rowHoverable={true}
          tableLayout={"fixed"}
        />
        <div className="text-center mt-20 mb-30 providerTable">
          <Pagination
            defaultCurrent={1}
            current={paginationData?.page_number}
            total={totalData ?? 0}
            onChange={handleChange}
            responsive={true}
            pageSize={paginationData?.page_size ?? 10}
            showSizeChanger
            onShowSizeChange={onShowSizeChange}
            pageSizeOptions={CONSTANT.PER_PAGE_RECORD}
          />
        </div>
      </div>
    </>
  );
};

export default ListComponent;
